import type { CmdbObject } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/cmdb-object.tsx';
import type { CmdbObjectSave } from './types.tsx';

export const transformCmdbField = (options: CmdbObject[]): CmdbObjectSave[] =>
	options.map((option) => ({
		id: option.id,
		objectId: option.objectId,
		workspaceId: option.workspaceId,
	}));
